import { createSlice } from "@reduxjs/toolkit";
import previewReportDownloadApi from "@custom/rtk-apis/report/previewReportDownload";

const initialState = {
  status: "",
  result:null,
  msg: "",
  loading: false,
  error: ""
};

const previewReportDownloadSlice = createSlice({
  name: "previewReportDownloadSlice",
  initialState,
  reducers: {revertStatus (state:any) { state.status = ""; }},
  extraReducers: (builder) => {
    console.log("----------", builder)
    builder
      .addCase(previewReportDownloadApi.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(previewReportDownloadApi.fulfilled, (state, { payload }) => {
        console.log("Fulfilled", payload)
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(previewReportDownloadApi.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.result = payload;
        state.loading = false;
      });
  },
});

export default previewReportDownloadSlice.reducer;
export const { revertStatus } = previewReportDownloadSlice.actions;
